import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';
import Portfolio from './components/Portfolio';
import SprachMeister from './components/pages/SprachMeister';
import SprachMeisterPrivacy from './components/pages/SprachMeisterPrivacy';
import BubbleShooter from './components/pages/BubbleShooter';
import BubbleShooterPrivacy from './components/pages/BubbleShooterPrivacy';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/sprachmeister" element={<SprachMeister />} />
            <Route path="/sprachmeister-privacy" element={<SprachMeisterPrivacy />} />
            <Route path="/bubbleshooter" element={<BubbleShooter />} />
            <Route path="/bubbleshooter-privacy" element={<BubbleShooterPrivacy />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;